import { createElement } from "react";
import React from "react";
import * as react from "react";
import { TaskMsg, useFeliz_UseElmish_React__React_useTaskDispatch_Static } from "../hooks/UseTaskDispatch.fs.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/./Interop.fs.js";
import { FSharpMap__TryFind, ofList, empty } from "../fable_modules/fable-library-js.4.24.0/Map.js";
import { int32ToString, compare, stringHash, safeHash, equals, createObj, comparePrimitives } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { PromiseBuilder__For_1565554B, PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.3.2.0/Promise.fs.js";
import { interpolate, toText, join, isNullOrWhiteSpace } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { promise } from "../fable_modules/Fable.Promise.3.2.0/PromiseImpl.fs.js";
import { newGuid } from "../fable_modules/fable-library-js.4.24.0/Guid.js";
import { defaultArg, some, bind, orElse, unwrap, map } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { DomainEntity__get_Name, DomainEntity__get_Id } from "../ClientTypes.fs.js";
import { Tags_MoveToLogicalLocation, Tags_MoveToPhysicalPosition, Tags_AssignEquipmentType, Tags_AssignCriticality, Tags_AssignCondition, Tags_AssignStatus, Tags_UpdateTagDetails, Tags_CreateTag } from "../ServerTypes.fs.js";
import { many, count, moveLogically as moveLogically_1, movePhysically as movePhysically_1, assignEquipmentType as assignEquipmentType_1, assignCriticality as assignCriticality_1, assignCondition as assignCondition_1, assignStatus as assignStatus_1, update as update_1, create as create_2 } from "../Api/Tags.fs.js";
import { Modal_ModalWithFooter, Modal_ModalWithBreakdown } from "./Modal.fs.js";
import { Helpers_combineClasses } from "../fable_modules/Feliz.Bulma.3.0.0/./ElementBuilders.fs.js";
import { iterate, reverse, map as map_2, ofSeq, append as append_1, tryHead, length, choose, empty as empty_1, singleton, cons, ofArray } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { DomainEntitySelector } from "../components/EntitySelector.fs.js";
import { DomainEntities } from "../DomainEvents.fs.js";
import { CriticalitySelector_CriticalitySelector, ConditionSelector_ConditionSelector, StatusSelector_StatusSelector } from "../components/Components.fs.js";
import { groupBy, List_groupBy } from "../fable_modules/fable-library-js.4.24.0/Seq2.js";
import { toString } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { length as length_1, map as map_1, mapIndexed, collect, empty as empty_2, singleton as singleton_1, append, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { tryGetProductionUnitType, tryGetProductionUnit, tryGetSystem, tryGetSubsystem, tryGetFacility, tryGetModule, tryGetArea, tryGetLocation, tryGetDocument, tryGetDiscipline, tryGetEquipmentType, getOptionalEntity } from "../Api/Cache.fs.js";
import { Csv_encode, EPM_Domain_Events_Attribute__Attribute_ValueString, EPM_Domain_Events_Status__Status_ToUrlString, EPM_Domain_Events_Criticality__Criticality_ToUrlString, EPM_Domain_Events_Condition__Condition_ToUrlString } from "../Prelude.fs.js";
import { utcNow, toString as toString_1 } from "../fable_modules/fable-library-js.4.24.0/Date.js";
import { union, ofSeq as ofSeq_1, empty as empty_3 } from "../fable_modules/fable-library-js.4.24.0/Set.js";
import { rangeDouble } from "../fable_modules/fable-library-js.4.24.0/Range.js";
import { StringBuilder__AppendLine_Z721C83C5, StringBuilder_$ctor } from "../fable_modules/fable-library-js.4.24.0/System.Text.js";
import file_saver from "file-saver";

export function Create(createInputProps) {
    let initial_8, xs_22, elms_1, elms, elms_3, elms_2, elms_4, elms_5, elms_6, elms_7, elms_8, elms_9;
    const close = createInputProps.close;
    const projectId = createInputProps.projectId;
    const patternInput = useFeliz_UseElmish_React__React_useTaskDispatch_Static();
    const taskDispatch = patternInput[1];
    const patternInput_1 = reactApi.useState("");
    const name = patternInput_1[0];
    const patternInput_2 = reactApi.useState("");
    const detail = patternInput_2[0];
    const patternInput_3 = reactApi.useState(undefined);
    const equipmentTypeOpt = patternInput_3[0];
    const patternInput_4 = reactApi.useState(undefined);
    const subsystemOpt = patternInput_4[0];
    const patternInput_5 = reactApi.useState(undefined);
    const locationOpt = patternInput_5[0];
    const patternInput_6 = reactApi.useState(undefined);
    const conditionOpt = patternInput_6[0];
    const patternInput_7 = reactApi.useState(undefined);
    const criticalityOpt = patternInput_7[0];
    const patternInput_8 = reactApi.useState(undefined);
    const statusOpt = patternInput_8[0];
    const labels = ((initial_8 = empty({
        Compare: comparePrimitives,
    }), reactApi.useState(initial_8)))[0];
    let create_1;
    const dependencies_1 = [name, detail, equipmentTypeOpt, subsystemOpt, locationOpt, conditionOpt, criticalityOpt, statusOpt, labels];
    create_1 = reactApi.useCallback(() => {
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            if (isNullOrWhiteSpace(name)) {
                return Promise.resolve();
            }
            else {
                const taskId = newGuid();
                taskDispatch(new TaskMsg(0, [taskId, "Create"]));
                const create = new Tags_CreateTag(name, detail, map(DomainEntity__get_Id, equipmentTypeOpt), map(DomainEntity__get_Id, subsystemOpt), map(DomainEntity__get_Id, locationOpt), conditionOpt, criticalityOpt, statusOpt, labels);
                taskDispatch(new TaskMsg(2, [taskId]));
                return create_2(projectId, create).then((_arg) => {
                    const result = _arg;
                    if (result.tag === 1) {
                        taskDispatch(new TaskMsg(6, [taskId, result.fields[0]]));
                        return Promise.resolve();
                    }
                    else {
                        taskDispatch(new TaskMsg(3, [taskId, undefined]));
                        return Promise.resolve();
                    }
                });
            }
        }));
        void pr;
    }, dependencies_1);
    return createElement(Modal_ModalWithBreakdown, {
        close: close,
        content: (xs_22 = [(elms_1 = ofArray([createElement("label", {
            className: "label",
            children: "Name",
        }), (elms = singleton(createElement("input", createObj(cons(["type", "text"], Helpers_combineClasses("input", ofArray([["onChange", (ev) => {
            patternInput_1[1](ev.target.value);
        }], ["defaultValue", name]])))))), createElement("div", {
            className: "control",
            children: reactApi.Children.toArray(Array.from(elms)),
        }))]), createElement("div", {
            className: "field",
            children: reactApi.Children.toArray(Array.from(elms_1)),
        })), (elms_3 = ofArray([createElement("label", {
            className: "label",
            children: "Detail",
        }), (elms_2 = singleton(createElement("input", createObj(cons(["type", "text"], Helpers_combineClasses("input", ofArray([["onChange", (ev_1) => {
            patternInput_2[1](ev_1.target.value);
        }], ["defaultValue", detail]])))))), createElement("div", {
            className: "control",
            children: reactApi.Children.toArray(Array.from(elms_2)),
        }))]), createElement("div", {
            className: "field",
            children: reactApi.Children.toArray(Array.from(elms_3)),
        })), (elms_4 = ofArray([createElement("label", {
            className: "label",
            children: "Equipment Type",
        }), createElement(DomainEntitySelector, {
            projectId: projectId,
            entityType: new DomainEntities(10, []),
            onSelectedEntityChange: patternInput_3[1],
            filters: empty_1(),
            isSmall: false,
        })]), createElement("div", {
            className: "field",
            children: reactApi.Children.toArray(Array.from(elms_4)),
        })), (elms_5 = ofArray([createElement("label", {
            className: "label",
            children: "Subsystem",
        }), createElement(DomainEntitySelector, {
            projectId: projectId,
            entityType: new DomainEntities(2, []),
            onSelectedEntityChange: patternInput_4[1],
            filters: empty_1(),
            isSmall: false,
        })]), createElement("div", {
            className: "field",
            children: reactApi.Children.toArray(Array.from(elms_5)),
        })), (elms_6 = ofArray([createElement("label", {
            className: "label",
            children: "Location",
        }), createElement(DomainEntitySelector, {
            projectId: projectId,
            entityType: new DomainEntities(8, []),
            onSelectedEntityChange: patternInput_5[1],
            filters: empty_1(),
            isSmall: false,
        })]), createElement("div", {
            className: "field",
            children: reactApi.Children.toArray(Array.from(elms_6)),
        })), (elms_7 = ofArray([createElement("label", {
            className: "label",
            children: "Status",
        }), createElement(StatusSelector_StatusSelector, {
            value: unwrap(statusOpt),
            required: false,
            onChange: patternInput_8[1],
        })]), createElement("div", {
            className: "field",
            children: reactApi.Children.toArray(Array.from(elms_7)),
        })), (elms_8 = ofArray([createElement("label", {
            className: "label",
            children: "Condition",
        }), createElement(ConditionSelector_ConditionSelector, {
            value: unwrap(conditionOpt),
            required: false,
            onChange: patternInput_6[1],
        })]), createElement("div", {
            className: "field",
            children: reactApi.Children.toArray(Array.from(elms_8)),
        })), (elms_9 = ofArray([createElement("label", {
            className: "label",
            children: "Criticality",
        }), createElement(CriticalitySelector_CriticalitySelector, {
            value: unwrap(criticalityOpt),
            required: false,
            onChange: patternInput_7[1],
        })]), createElement("div", {
            className: "field",
            children: reactApi.Children.toArray(Array.from(elms_9)),
        }))], react.createElement(react.Fragment, {}, ...xs_22)),
        submit: create_1,
        submitText: "Create",
        tasks: patternInput[0],
        title: "Create",
    });
}

export function Update(updateInputProps) {
    let xs_10, elms_1, elms, elms_3, elms_2;
    const close = updateInputProps.close;
    const tag = updateInputProps.tag;
    const projectId = updateInputProps.projectId;
    const patternInput = useFeliz_UseElmish_React__React_useTaskDispatch_Static();
    const taskDispatch = patternInput[1];
    const patternInput_1 = reactApi.useState(tag.Name);
    const name = patternInput_1[0];
    const patternInput_2 = reactApi.useState(tag.Detail);
    const detail = patternInput_2[0];
    let updates;
    const dependencies_1 = [name, detail];
    updates = reactApi.useCallback(() => {
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            if (isNullOrWhiteSpace(name)) {
                return Promise.resolve();
            }
            else {
                const taskId = newGuid();
                taskDispatch(new TaskMsg(0, [taskId, `Update ${name}`]));
                const update = new Tags_UpdateTagDetails(name, detail);
                taskDispatch(new TaskMsg(2, [taskId]));
                return update_1(projectId, tag.Id, update).then((_arg) => {
                    const result = _arg;
                    if (result.tag === 1) {
                        taskDispatch(new TaskMsg(6, [taskId, result.fields[0]]));
                        return Promise.resolve();
                    }
                    else {
                        taskDispatch(new TaskMsg(3, [taskId, undefined]));
                        return Promise.resolve();
                    }
                });
            }
        }));
        void pr;
    }, dependencies_1);
    return createElement(Modal_ModalWithBreakdown, {
        close: close,
        content: (xs_10 = [(elms_1 = ofArray([createElement("label", {
            className: "label",
            children: "Name",
        }), (elms = singleton(createElement("input", createObj(cons(["type", "text"], Helpers_combineClasses("input", ofArray([["onChange", (ev) => {
            patternInput_1[1](ev.target.value);
        }], ["defaultValue", name]])))))), createElement("div", {
            className: "control",
            children: reactApi.Children.toArray(Array.from(elms)),
        }))]), createElement("div", {
            className: "field",
            children: reactApi.Children.toArray(Array.from(elms_1)),
        })), (elms_3 = ofArray([createElement("label", {
            className: "label",
            children: "Detail",
        }), (elms_2 = singleton(createElement("input", createObj(cons(["type", "text"], Helpers_combineClasses("input", ofArray([["onChange", (ev_1) => {
            patternInput_2[1](ev_1.target.value);
        }], ["defaultValue", detail]])))))), createElement("div", {
            className: "control",
            children: reactApi.Children.toArray(Array.from(elms_2)),
        }))]), createElement("div", {
            className: "field",
            children: reactApi.Children.toArray(Array.from(elms_3)),
        }))], react.createElement(react.Fragment, {}, ...xs_10)),
        submit: updates,
        submitText: "Update",
        tasks: patternInput[0],
        title: "Update",
    });
}

export function AssignStatus(assignStatusInputProps) {
    let elms;
    const close = assignStatusInputProps.close;
    const tags = assignStatusInputProps.tags;
    const projectId = assignStatusInputProps.projectId;
    const patternInput = useFeliz_UseElmish_React__React_useTaskDispatch_Static();
    const taskDispatch = patternInput[1];
    const patternInput_1 = reactApi.useState(undefined);
    const statusOpt = patternInput_1[0];
    let initialStatus;
    const dependencies_1 = [tags];
    initialStatus = reactApi.useMemo(() => {
        const statuses = choose((m) => m.Status, tags);
        if (length(List_groupBy((x) => x, statuses, {
            Equals: equals,
            GetHashCode: safeHash,
        })) > 1) {
            return undefined;
        }
        else {
            return tryHead(statuses);
        }
    }, dependencies_1);
    let assigns;
    const dependencies_1_1 = [statusOpt];
    assigns = reactApi.useCallback(() => {
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            if (statusOpt == null) {
                return Promise.resolve();
            }
            else {
                const status = statusOpt;
                const assignStatus = new Tags_AssignStatus(status);
                return PromiseBuilder__For_1565554B(promise, tags, (_arg) => {
                    const tag = _arg;
                    taskDispatch(new TaskMsg(0, [tag.Id, `Assign ${tag.Name} To Status : ${toString(status)}`]));
                    taskDispatch(new TaskMsg(2, [tag.Id]));
                    return assignStatus_1(projectId, tag.Id, assignStatus).then((_arg_1) => {
                        const result = _arg_1;
                        if (result.tag === 1) {
                            taskDispatch(new TaskMsg(6, [tag.Id, result.fields[0]]));
                            return Promise.resolve();
                        }
                        else {
                            taskDispatch(new TaskMsg(3, [tag.Id, undefined]));
                            return Promise.resolve();
                        }
                    });
                });
            }
        }));
        void pr;
    }, dependencies_1_1);
    return createElement(Modal_ModalWithBreakdown, {
        close: close,
        content: (elms = ofArray([createElement("label", {
            className: "label",
            children: "Status",
        }), createElement(StatusSelector_StatusSelector, {
            value: unwrap(initialStatus),
            required: true,
            onChange: patternInput_1[1],
        })]), createElement("div", {
            className: "field",
            children: reactApi.Children.toArray(Array.from(elms)),
        })),
        submit: assigns,
        submitText: "Assign",
        tasks: patternInput[0],
        title: "Assign Status",
    });
}

export function AssignCondition(assignConditionInputProps) {
    let elms;
    const close = assignConditionInputProps.close;
    const tags = assignConditionInputProps.tags;
    const projectId = assignConditionInputProps.projectId;
    const patternInput = useFeliz_UseElmish_React__React_useTaskDispatch_Static();
    const taskDispatch = patternInput[1];
    const patternInput_1 = reactApi.useState(undefined);
    const conditionOpt = patternInput_1[0];
    let initialCondition;
    const dependencies_1 = [tags];
    initialCondition = reactApi.useMemo(() => {
        const conditions = choose((m) => m.Condition, tags);
        if (length(List_groupBy((x) => x, conditions, {
            Equals: equals,
            GetHashCode: safeHash,
        })) > 1) {
            return undefined;
        }
        else {
            return tryHead(conditions);
        }
    }, dependencies_1);
    let assigns;
    const dependencies_1_1 = [conditionOpt];
    assigns = reactApi.useCallback(() => {
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            if (conditionOpt == null) {
                return Promise.resolve();
            }
            else {
                const condition = conditionOpt;
                const assignCondition = new Tags_AssignCondition(condition);
                return PromiseBuilder__For_1565554B(promise, tags, (_arg) => {
                    const tag = _arg;
                    taskDispatch(new TaskMsg(0, [tag.Id, `Assign ${tag.Name} To Condition : ${toString(condition)}`]));
                    taskDispatch(new TaskMsg(2, [tag.Id]));
                    return assignCondition_1(projectId, tag.Id, assignCondition).then((_arg_1) => {
                        const result = _arg_1;
                        if (result.tag === 1) {
                            taskDispatch(new TaskMsg(6, [tag.Id, result.fields[0]]));
                            return Promise.resolve();
                        }
                        else {
                            taskDispatch(new TaskMsg(3, [tag.Id, undefined]));
                            return Promise.resolve();
                        }
                    });
                });
            }
        }));
        void pr;
    }, dependencies_1_1);
    return createElement(Modal_ModalWithBreakdown, {
        close: close,
        content: (elms = ofArray([createElement("label", {
            className: "label",
            children: "Condition",
        }), createElement(ConditionSelector_ConditionSelector, {
            value: unwrap(initialCondition),
            required: true,
            onChange: patternInput_1[1],
        })]), createElement("div", {
            className: "field",
            children: reactApi.Children.toArray(Array.from(elms)),
        })),
        submit: assigns,
        submitText: "Assign",
        tasks: patternInput[0],
        title: "Assign Condition",
    });
}

export function AssignCriticality(assignCriticalityInputProps) {
    let elms;
    const close = assignCriticalityInputProps.close;
    const tags = assignCriticalityInputProps.tags;
    const projectId = assignCriticalityInputProps.projectId;
    const patternInput = useFeliz_UseElmish_React__React_useTaskDispatch_Static();
    const taskDispatch = patternInput[1];
    const patternInput_1 = reactApi.useState(undefined);
    const criticalityOpt = patternInput_1[0];
    let initialCriticality;
    const dependencies_1 = [tags];
    initialCriticality = reactApi.useMemo(() => {
        const criticalities = choose((m) => m.Criticality, tags);
        if (length(List_groupBy((x) => x, criticalities, {
            Equals: equals,
            GetHashCode: safeHash,
        })) > 1) {
            return undefined;
        }
        else {
            return tryHead(criticalities);
        }
    }, dependencies_1);
    let assigns;
    const dependencies_1_1 = [criticalityOpt];
    assigns = reactApi.useCallback(() => {
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            if (criticalityOpt == null) {
                return Promise.resolve();
            }
            else {
                const criticality = criticalityOpt;
                const assignCriticality = new Tags_AssignCriticality(criticality);
                return PromiseBuilder__For_1565554B(promise, tags, (_arg) => {
                    const tag = _arg;
                    taskDispatch(new TaskMsg(0, [tag.Id, `Assign ${tag.Name} To Criticality : ${toString(criticality)}`]));
                    taskDispatch(new TaskMsg(2, [tag.Id]));
                    return assignCriticality_1(projectId, tag.Id, assignCriticality).then((_arg_1) => {
                        const result = _arg_1;
                        if (result.tag === 1) {
                            taskDispatch(new TaskMsg(6, [tag.Id, result.fields[0]]));
                            return Promise.resolve();
                        }
                        else {
                            taskDispatch(new TaskMsg(3, [tag.Id, undefined]));
                            return Promise.resolve();
                        }
                    });
                });
            }
        }));
        void pr;
    }, dependencies_1_1);
    return createElement(Modal_ModalWithBreakdown, {
        close: close,
        content: (elms = ofArray([createElement("label", {
            className: "label",
            children: "Criticality",
        }), createElement(CriticalitySelector_CriticalitySelector, {
            value: unwrap(initialCriticality),
            required: true,
            onChange: patternInput_1[1],
        })]), createElement("div", {
            className: "field",
            children: reactApi.Children.toArray(Array.from(elms)),
        })),
        submit: assigns,
        submitText: "Assign",
        tasks: patternInput[0],
        title: "Assign Criticality",
    });
}

export function AssignEquipmentType(assignEquipmentTypeInputProps) {
    let elms;
    const close = assignEquipmentTypeInputProps.close;
    const tags = assignEquipmentTypeInputProps.tags;
    const projectId = assignEquipmentTypeInputProps.projectId;
    const patternInput = useFeliz_UseElmish_React__React_useTaskDispatch_Static();
    const taskDispatch = patternInput[1];
    const patternInput_1 = reactApi.useState(undefined);
    const equipmentTypeOpt = patternInput_1[0];
    let initialEquipmentType;
    const dependencies_1 = [tags];
    initialEquipmentType = reactApi.useMemo(() => {
        const equipmentTypes = choose((m) => m.EquipmentTypeId, tags);
        if (length(List_groupBy((x) => x, equipmentTypes, {
            Equals: (x_1, y) => (x_1 === y),
            GetHashCode: stringHash,
        })) > 1) {
            return undefined;
        }
        else {
            return tryHead(equipmentTypes);
        }
    }, dependencies_1);
    let assigns;
    const dependencies_1_1 = [equipmentTypeOpt];
    assigns = reactApi.useCallback(() => {
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            if (equipmentTypeOpt == null) {
                return Promise.resolve();
            }
            else {
                const equipmentType = equipmentTypeOpt;
                const assignEquipmentType = new Tags_AssignEquipmentType(DomainEntity__get_Id(equipmentType));
                return PromiseBuilder__For_1565554B(promise, tags, (_arg) => {
                    const tag = _arg;
                    taskDispatch(new TaskMsg(0, [tag.Id, `Assign ${tag.Name} To Equipment Type : ${DomainEntity__get_Name(equipmentType)}`]));
                    taskDispatch(new TaskMsg(2, [tag.Id]));
                    return assignEquipmentType_1(projectId, tag.Id, assignEquipmentType).then((_arg_1) => {
                        const result = _arg_1;
                        if (result.tag === 1) {
                            taskDispatch(new TaskMsg(6, [tag.Id, result.fields[0]]));
                            return Promise.resolve();
                        }
                        else {
                            taskDispatch(new TaskMsg(3, [tag.Id, undefined]));
                            return Promise.resolve();
                        }
                    });
                });
            }
        }));
        void pr;
    }, dependencies_1_1);
    return createElement(Modal_ModalWithBreakdown, {
        close: close,
        content: (elms = ofArray([createElement("label", {
            className: "label",
            children: "Equipment Type",
        }), createElement(DomainEntitySelector, {
            projectId: projectId,
            entityType: new DomainEntities(10, []),
            initialEntity: unwrap(initialEquipmentType),
            onSelectedEntityChange: patternInput_1[1],
            filters: empty_1(),
            isSmall: false,
        })]), createElement("div", {
            className: "field",
            children: reactApi.Children.toArray(Array.from(elms)),
        })),
        submit: assigns,
        submitText: "Assign",
        tasks: patternInput[0],
        title: "Assign Equipment Type",
    });
}

export function MovePhysically(movePhysicallyInputProps) {
    let xs_15, elems, elms, children;
    const close = movePhysicallyInputProps.close;
    const tags = movePhysicallyInputProps.tags;
    const projectId = movePhysicallyInputProps.projectId;
    const patternInput = useFeliz_UseElmish_React__React_useTaskDispatch_Static();
    const taskDispatch = patternInput[1];
    const patternInput_1 = reactApi.useState(undefined);
    const locationOpt = patternInput_1[0];
    const patternInput_2 = reactApi.useState(undefined);
    const areaOpt = patternInput_2[0];
    const patternInput_3 = reactApi.useState(undefined);
    const moduleOpt = patternInput_3[0];
    const patternInput_4 = reactApi.useState(undefined);
    const facilityOpt = patternInput_4[0];
    const patternInput_5 = reactApi.useState("location");
    const tab = patternInput_5[0];
    const setTab = patternInput_5[1];
    const chosenPhysicalPositionOpt = orElse(orElse(orElse(locationOpt, areaOpt), moduleOpt), facilityOpt);
    let assigns;
    const dependencies_1 = [chosenPhysicalPositionOpt];
    assigns = reactApi.useCallback(() => {
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            if (chosenPhysicalPositionOpt == null) {
                return Promise.resolve();
            }
            else {
                const chosenPhysicalPosition = chosenPhysicalPositionOpt;
                let movePhysically;
                const AreaId = map(DomainEntity__get_Id, areaOpt);
                const ModuleId = map(DomainEntity__get_Id, moduleOpt);
                movePhysically = (new Tags_MoveToPhysicalPosition(map(DomainEntity__get_Id, locationOpt), AreaId, ModuleId, map(DomainEntity__get_Id, facilityOpt)));
                return PromiseBuilder__For_1565554B(promise, tags, (_arg) => {
                    const tag = _arg;
                    taskDispatch(new TaskMsg(0, [tag.Id, `Move ${tag.Name} Physically : ${DomainEntity__get_Name(chosenPhysicalPosition)}`]));
                    taskDispatch(new TaskMsg(2, [tag.Id]));
                    return movePhysically_1(projectId, tag.Id, movePhysically).then((_arg_1) => {
                        const result = _arg_1;
                        if (result.tag === 1) {
                            taskDispatch(new TaskMsg(6, [tag.Id, result.fields[0]]));
                            return Promise.resolve();
                        }
                        else {
                            taskDispatch(new TaskMsg(3, [tag.Id, undefined]));
                            return Promise.resolve();
                        }
                    });
                });
            }
        }));
        void pr;
    }, dependencies_1);
    return createElement(Modal_ModalWithBreakdown, {
        close: close,
        content: (xs_15 = [createElement("div", createObj(Helpers_combineClasses("tabs", ofArray([["className", "is-centered"], ["className", "is-fullwidth"], ["className", "is-toggle"], (elems = [createElement("li", createObj(Helpers_combineClasses("", toList(delay(() => append((tab === "location") ? singleton_1(["className", "is-active"]) : empty_2(), delay(() => singleton_1(["children", createElement("a", {
            children: "Locations",
            onClick: (e_4) => {
                e_4.preventDefault();
                setTab("location");
            },
        })])))))))), createElement("li", createObj(Helpers_combineClasses("", toList(delay(() => append((tab === "area") ? singleton_1(["className", "is-active"]) : empty_2(), delay(() => singleton_1(["children", createElement("a", {
            children: "Areas",
            onClick: (e_5) => {
                e_5.preventDefault();
                setTab("area");
            },
        })])))))))), createElement("li", createObj(Helpers_combineClasses("", toList(delay(() => append((tab === "module") ? singleton_1(["className", "is-active"]) : empty_2(), delay(() => singleton_1(["children", createElement("a", {
            children: "Modules",
            onClick: (e_6) => {
                e_6.preventDefault();
                setTab("module");
            },
        })])))))))), createElement("li", createObj(Helpers_combineClasses("", toList(delay(() => append((tab === "facility") ? singleton_1(["className", "is-active"]) : empty_2(), delay(() => singleton_1(["children", createElement("a", {
            children: "Facilities",
            onClick: (e_7) => {
                e_7.preventDefault();
                setTab("facility");
            },
        })]))))))))], ["children", reactApi.Children.toArray(Array.from(elems))])])))), (elms = singleton((children = toList(delay(() => ((tab === "area") ? singleton_1(createElement(DomainEntitySelector, {
            projectId: projectId,
            entityType: new DomainEntities(7, []),
            onSelectedEntityChange: patternInput_2[1],
            filters: empty_1(),
            isSmall: false,
        })) : ((tab === "module") ? singleton_1(createElement(DomainEntitySelector, {
            projectId: projectId,
            entityType: new DomainEntities(6, []),
            onSelectedEntityChange: patternInput_3[1],
            filters: empty_1(),
            isSmall: false,
        })) : ((tab === "facility") ? singleton_1(createElement(DomainEntitySelector, {
            projectId: projectId,
            entityType: new DomainEntities(3, []),
            onSelectedEntityChange: patternInput_4[1],
            filters: empty_1(),
            isSmall: false,
        })) : singleton_1(createElement(DomainEntitySelector, {
            projectId: projectId,
            entityType: new DomainEntities(8, []),
            onSelectedEntityChange: patternInput_1[1],
            filters: empty_1(),
            isSmall: false,
        }))))))), createElement("ul", {
            children: reactApi.Children.toArray(Array.from(children)),
        }))), createElement("div", {
            className: "field",
            children: reactApi.Children.toArray(Array.from(elms)),
        }))], react.createElement(react.Fragment, {}, ...xs_15)),
        submit: assigns,
        submitText: "Move",
        tasks: patternInput[0],
        title: "Move Physically",
    });
}

export function MoveLogically(moveLogicallyInputProps) {
    let xs_12, elems, children, elms, children_2;
    const close = moveLogicallyInputProps.close;
    const tags = moveLogicallyInputProps.tags;
    const projectId = moveLogicallyInputProps.projectId;
    const patternInput = useFeliz_UseElmish_React__React_useTaskDispatch_Static();
    const taskDispatch = patternInput[1];
    const patternInput_1 = reactApi.useState(undefined);
    const subsystemOpt = patternInput_1[0];
    const patternInput_2 = reactApi.useState(undefined);
    const systemOpt = patternInput_2[0];
    const patternInput_3 = reactApi.useState(undefined);
    const productionUnit = patternInput_3[0];
    const patternInput_4 = reactApi.useState("subsystem");
    const tab = patternInput_4[0];
    const setTab = patternInput_4[1];
    const chosenLogicalPositionOpt = orElse(orElse(subsystemOpt, systemOpt), productionUnit);
    let assigns;
    const dependencies_1 = [chosenLogicalPositionOpt];
    assigns = reactApi.useCallback(() => {
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            if (chosenLogicalPositionOpt == null) {
                return Promise.resolve();
            }
            else {
                const chosenLogicalPosition = chosenLogicalPositionOpt;
                const moveLogically = new Tags_MoveToLogicalLocation(map(DomainEntity__get_Id, subsystemOpt), map(DomainEntity__get_Id, systemOpt), map(DomainEntity__get_Id, productionUnit));
                return PromiseBuilder__For_1565554B(promise, tags, (_arg) => {
                    const tag = _arg;
                    taskDispatch(new TaskMsg(0, [tag.Id, `Move ${tag.Name} Logically : ${DomainEntity__get_Name(chosenLogicalPosition)}`]));
                    taskDispatch(new TaskMsg(2, [tag.Id]));
                    return moveLogically_1(projectId, tag.Id, moveLogically).then((_arg_1) => {
                        const result = _arg_1;
                        if (result.tag === 1) {
                            taskDispatch(new TaskMsg(6, [tag.Id, result.fields[0]]));
                            return Promise.resolve();
                        }
                        else {
                            taskDispatch(new TaskMsg(3, [tag.Id, undefined]));
                            return Promise.resolve();
                        }
                    });
                });
            }
        }));
        void pr;
    }, dependencies_1);
    return createElement(Modal_ModalWithBreakdown, {
        close: close,
        content: (xs_12 = [createElement("div", createObj(Helpers_combineClasses("tabs", ofArray([["className", "is-centered"], ["className", "is-fullwidth"], ["className", "is-toggle"], (elems = [(children = ofArray([createElement("li", createObj(Helpers_combineClasses("", toList(delay(() => append((tab === "subsystem") ? singleton_1(["className", "is-active"]) : empty_2(), delay(() => singleton_1(["children", createElement("a", {
            children: "Subsystems",
            onClick: (e_3) => {
                e_3.preventDefault();
                setTab("subsystem");
            },
        })])))))))), createElement("li", createObj(Helpers_combineClasses("", toList(delay(() => append((tab === "system") ? singleton_1(["className", "is-active"]) : empty_2(), delay(() => singleton_1(["children", createElement("a", {
            children: "Systems",
            onClick: (e_4) => {
                e_4.preventDefault();
                setTab("system");
            },
        })])))))))), createElement("li", createObj(Helpers_combineClasses("", toList(delay(() => append((tab === "productionUnit") ? singleton_1(["className", "is-active"]) : empty_2(), delay(() => singleton_1(["children", createElement("a", {
            children: "Production Units",
            onClick: (e_5) => {
                e_5.preventDefault();
                setTab("productionUnit");
            },
        })]))))))))]), createElement("ul", {
            children: reactApi.Children.toArray(Array.from(children)),
        }))], ["children", reactApi.Children.toArray(Array.from(elems))])])))), (elms = singleton((children_2 = toList(delay(() => ((tab === "system") ? singleton_1(createElement(DomainEntitySelector, {
            projectId: projectId,
            entityType: new DomainEntities(1, []),
            onSelectedEntityChange: patternInput_2[1],
            filters: empty_1(),
            isSmall: false,
        })) : ((tab === "productionUnit") ? singleton_1(createElement(DomainEntitySelector, {
            projectId: projectId,
            entityType: new DomainEntities(13, []),
            onSelectedEntityChange: patternInput_3[1],
            filters: empty_1(),
            isSmall: false,
        })) : singleton_1(createElement(DomainEntitySelector, {
            projectId: projectId,
            entityType: new DomainEntities(2, []),
            onSelectedEntityChange: patternInput_1[1],
            filters: empty_1(),
            isSmall: false,
        })))))), createElement("ul", {
            children: reactApi.Children.toArray(Array.from(children_2)),
        }))), createElement("div", {
            className: "field",
            children: reactApi.Children.toArray(Array.from(elms)),
        }))], react.createElement(react.Fragment, {}, ...xs_12)),
        submit: assigns,
        submitText: "Move",
        tasks: patternInput[0],
        title: "Move Logically",
    });
}

const exportHeaders = ofArray([{
    key: "id",
    name: "Id",
}, {
    key: "name",
    name: "Name",
}, {
    key: "detail",
    name: "Detail",
}, {
    key: "equipmentTypeId",
    name: "EquipmentTypeId",
}, {
    key: "equipmentTypeName",
    name: "EquipmentTypeName",
}, {
    key: "discplineId",
    name: "DiscplineId",
}, {
    key: "discplineName",
    name: "DiscplineName",
}, {
    key: "sourceDocumentId",
    name: "SourceDocumentId",
}, {
    key: "sourceDocumentName",
    name: "SourceDocumentName",
}, {
    key: "productionUnitTypeId",
    name: "ProductionUnitTypeId",
}, {
    key: "productionUnitTypeName",
    name: "ProductionUnitTypeName",
}, {
    key: "productionUnitId",
    name: "ProductionUnitId",
}, {
    key: "productionUnitName",
    name: "ProductionUnitName",
}, {
    key: "systemId",
    name: "SystemId",
}, {
    key: "systemName",
    name: "SystemName",
}, {
    key: "subsystemId",
    name: "SubsystemId",
}, {
    key: "subsystemName",
    name: "SubsystemName",
}, {
    key: "facilityId",
    name: "FacilityId",
}, {
    key: "facilityName",
    name: "FacilityName",
}, {
    key: "moduleId",
    name: "ModuleId",
}, {
    key: "moduleName",
    name: "ModuleName",
}, {
    key: "areaId",
    name: "AreaId",
}, {
    key: "areaName",
    name: "AreaName",
}, {
    key: "locationId",
    name: "LocationId",
}, {
    key: "locationName",
    name: "LocationName",
}, {
    key: "condition",
    name: "Condition",
}, {
    key: "criticality",
    name: "Criticality",
}, {
    key: "status",
    name: "Status",
}, {
    key: "deletedOn",
    name: "DeletedOn",
}]);

function exportTag(cache, tag, projectId) {
    return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (getOptionalEntity((projectId_1, entityId) => tryGetEquipmentType(cache, projectId_1, entityId), projectId, tag.EquipmentTypeId).then((_arg) => {
        const equipmentTypeOpt = _arg;
        const disciplineIdOpt = bind((eq) => eq.DisciplineId, equipmentTypeOpt);
        return getOptionalEntity((projectId_2, entityId_1) => tryGetDiscipline(cache, projectId_2, entityId_1), projectId, disciplineIdOpt).then((_arg_1) => {
            const disciplineOpt = _arg_1;
            return getOptionalEntity((projectId_3, entityId_2) => tryGetDocument(cache, projectId_3, entityId_2), projectId, tag.SourceDocumentId).then((_arg_2) => {
                const sourceDocumentOpt = _arg_2;
                return getOptionalEntity((projectId_4, entityId_3) => tryGetLocation(cache, projectId_4, entityId_3), projectId, tag.LocationId).then((_arg_3) => {
                    const locationOpt = _arg_3;
                    const areaIdOpt = orElse(tag.AreaId, bind((location) => location.AreaId, locationOpt));
                    return getOptionalEntity((projectId_5, entityId_4) => tryGetArea(cache, projectId_5, entityId_4), projectId, areaIdOpt).then((_arg_4) => {
                        const areaOpt = _arg_4;
                        const moduleIdOpt = orElse(tag.ModuleId, bind((area) => area.ModuleId, areaOpt));
                        return getOptionalEntity((projectId_6, entityId_5) => tryGetModule(cache, projectId_6, entityId_5), projectId, moduleIdOpt).then((_arg_5) => {
                            const moduleOpt = _arg_5;
                            const facilityIdOpt = orElse(tag.FacilityId, bind((m) => m.FacilityId, moduleOpt));
                            return getOptionalEntity((projectId_7, entityId_6) => tryGetFacility(cache, projectId_7, entityId_6), projectId, facilityIdOpt).then((_arg_6) => {
                                const facilityOpt = _arg_6;
                                return getOptionalEntity((projectId_8, entityId_7) => tryGetSubsystem(cache, projectId_8, entityId_7), projectId, tag.SubsystemId).then((_arg_7) => {
                                    const subsystemOpt = _arg_7;
                                    const systemIdOpt = orElse(tag.SubsystemId, map((subsystem) => subsystem.SystemId, subsystemOpt));
                                    return getOptionalEntity((projectId_9, entityId_8) => tryGetSystem(cache, projectId_9, entityId_8), projectId, systemIdOpt).then((_arg_8) => {
                                        const systemOpt = _arg_8;
                                        const productionUnitIdOpt = orElse(tag.ProductionUnitId, bind((sys) => sys.ProductionUnitId, systemOpt));
                                        return getOptionalEntity((projectId_10, entityId_9) => tryGetProductionUnit(cache, projectId_10, entityId_9), projectId, productionUnitIdOpt).then((_arg_9) => {
                                            const productionUnitOpt = _arg_9;
                                            const productionUnitTypeIdOpt = map((productionUnit) => productionUnit.ProductionUnitTypeId, productionUnitOpt);
                                            return getOptionalEntity((projectId_11, entityId_10) => tryGetProductionUnitType(cache, projectId_11, entityId_10), projectId, productionUnitTypeIdOpt).then((_arg_10) => {
                                                let list_6, list_4;
                                                const productionUnitTypeOpt = _arg_10;
                                                return Promise.resolve(ofList((list_6 = ((list_4 = append_1(ofArray([["id", tag.Id], ["name", tag.Name], ["detail", tag.Detail]]), choose((x) => x, ofArray([map((e) => ["equipmentTypeId", e.Id], equipmentTypeOpt), map((e_1) => ["equipmentTypeName", e_1.Name], equipmentTypeOpt), map((e_2) => ["discplineId", e_2.Id], disciplineOpt), map((e_3) => ["discplineName", e_3.Name], disciplineOpt), map((e_4) => ["sourceDocumentId", e_4.Id], sourceDocumentOpt), map((e_5) => ["sourceDocumentName", e_5.Name], sourceDocumentOpt), map((e_6) => ["productionUnitTypeId", e_6.Id], productionUnitTypeOpt), map((e_7) => ["productionUnitTypeName", e_7.Name], productionUnitTypeOpt), map((e_8) => ["productionUnitId", e_8.Id], productionUnitOpt), map((e_9) => ["productionUnitName", e_9.Name], productionUnitOpt), map((e_10) => ["systemId", e_10.Id], systemOpt), map((e_11) => ["systemName", e_11.Name], systemOpt), map((e_12) => ["subsystemId", e_12.Id], subsystemOpt), map((e_13) => ["subsystemName", e_13.Name], subsystemOpt), map((e_14) => ["facilityId", e_14.Id], facilityOpt), map((e_15) => ["facilityName", e_15.Name], facilityOpt), map((e_16) => ["moduleId", e_16.Id], moduleOpt), map((e_17) => ["moduleName", e_17.Name], moduleOpt), map((e_18) => ["areaId", e_18.Id], areaOpt), map((e_19) => ["areaName", e_19.Name], areaOpt), map((e_20) => ["locationId", e_20.Id], locationOpt), map((e_21) => ["locationName", e_21.Name], locationOpt), map((e_22) => ["condition", EPM_Domain_Events_Condition__Condition_ToUrlString(e_22)], tag.Condition), map((e_23) => ["criticality", EPM_Domain_Events_Criticality__Criticality_ToUrlString(e_23)], tag.Criticality), map((e_24) => ["status", EPM_Domain_Events_Status__Status_ToUrlString(e_24)], tag.Status), map((e_25) => ["deletedOn", toString_1(e_25, "O")], tag.DeletedOn)]))), append_1(ofSeq(collect((kv) => collect((x_1) => x_1, mapIndexed((i, v) => singleton([`Label:${kv[0]}:${i}`, v]), kv[1])), tag.Labels)), list_4))), append_1(ofSeq(collect((x_2) => x_2, map_1((kv_1) => singleton([`Attribute:${kv_1[0]}`, EPM_Domain_Events_Attribute__Attribute_ValueString(kv_1[1])]), tag.Attributes))), list_6)), {
                                                    Compare: comparePrimitives,
                                                }));
                                            });
                                        });
                                    });
                                });
                            });
                        });
                    });
                });
            });
        });
    }))));
}

function downloadCSV(setProcessing, setTotal, setFetched, projectId, filters) {
    const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        setProcessing(true);
        const cache = new Map([]);
        return count(projectId, filters).then((_arg) => {
            let initialCount, chunks;
            const initialCountResult = _arg;
            let results = empty_1();
            let labelHeaders = empty_3({
                Compare: compare,
            });
            let attributeHeaders = empty_3({
                Compare: compare,
            });
            return ((initialCountResult.tag === 0) ? ((initialCount = (initialCountResult.fields[0] | 0), (setTotal(initialCount), (chunks = ((~~(initialCount / 100) + (((initialCount % 100) > 0) ? 1 : 0)) | 0), PromiseBuilder__For_1565554B(promise, rangeDouble(0, 1, chunks - 1), (_arg_1) => {
                const apiParams = ofArray([["fetch", int32ToString(100)], ["offset", int32ToString(_arg_1 * 100)]]);
                return many(projectId, apiParams, filters).then((_arg_2) => {
                    const dataResult = _arg_2;
                    if (dataResult.tag === 0) {
                        return PromiseBuilder__For_1565554B(promise, dataResult.fields[0], (_arg_3) => {
                            const tag = _arg_3;
                            const tagLabelHeaders = ofSeq_1(collect((tupledArg) => {
                                const key = tupledArg[0];
                                return map_2((n_1) => ({
                                    key: `Label:${key}:${n_1}`,
                                    name: `Label:${key}`,
                                }), toList(rangeDouble(0, 1, length_1(tupledArg[1]) - 1)));
                            }, groupBy((x_2) => x_2, map_1((kv) => kv[0], tag.Labels), {
                                Equals: (x_3, y_2) => (x_3 === y_2),
                                GetHashCode: stringHash,
                            })), {
                                Compare: compare,
                            });
                            labelHeaders = union(labelHeaders, tagLabelHeaders);
                            const tagAttributeHeaders = ofSeq_1(map_1((kv_1) => ({
                                key: `Attribute:${kv_1[0]}`,
                                name: `Attribute:${kv_1[0]}`,
                            }), tag.Attributes), {
                                Compare: compare,
                            });
                            attributeHeaders = union(attributeHeaders, tagAttributeHeaders);
                            return exportTag(cache, tag, projectId).then((_arg_4) => {
                                results = cons(_arg_4, results);
                                setFetched(length(results));
                                return Promise.resolve();
                            });
                        });
                    }
                    else {
                        console.error(some(dataResult.fields[0]));
                        return Promise.resolve();
                    }
                });
            }).then(() => PromiseBuilder__Delay_62FBFDE1(promise, () => {
                let source_4;
                const processedData_1 = reverse(results);
                const headers = ofSeq(append(exportHeaders, (source_4 = attributeHeaders, append(labelHeaders, source_4))));
                const csv = StringBuilder_$ctor();
                StringBuilder__AppendLine_Z721C83C5(csv, join(",", map_2((header) => Csv_encode(header.name), headers)));
                iterate((row) => {
                    StringBuilder__AppendLine_Z721C83C5(csv, row);
                }, map_2((data) => join(",", map_2((header_1) => defaultArg(map(Csv_encode, FSharpMap__TryFind(data, header_1.key)), ""), headers)), processedData_1));
                const content = toString(csv);
                const now = toString_1(utcNow(), "yyyy-MM-dd hh:mm:ss");
                file_saver(new Blob([content], { 'type': "text/csv" }), `tag-export-${now}.csv`);
                return Promise.resolve();
            })))))) : ((console.error(some(initialCountResult.fields[0])), Promise.resolve()))).then(() => PromiseBuilder__Delay_62FBFDE1(promise, () => {
                setProcessing(false);
                return Promise.resolve();
            }));
        });
    }));
    void pr;
}

export function Export(exportInputProps) {
    const close = exportInputProps.close;
    const filters = exportInputProps.filters;
    const projectId = exportInputProps.projectId;
    const patternInput = reactApi.useState(0);
    const total = patternInput[0] | 0;
    const patternInput_1 = reactApi.useState(0);
    const fetched = patternInput_1[0] | 0;
    const patternInput_2 = reactApi.useState(false);
    const processing = patternInput_2[0];
    return createElement(Modal_ModalWithFooter, {
        close: close,
        content: createElement("progress", createObj(Helpers_combineClasses("progress", ofArray([["className", "is-primary"], ["max", total], ["value", fetched], ["title", toText(interpolate("%.2f%P()%%", [(total === 0) ? 0 : ((fetched / total) * 100)]))]])))),
        disabled: processing,
        footer: singleton(createElement("button", createObj(Helpers_combineClasses("button", toList(delay(() => append(processing ? singleton_1(["className", "is-loading"]) : empty_2(), delay(() => append(singleton_1(["disabled", processing]), delay(() => append(singleton_1(["children", "Download"]), delay(() => singleton_1(["onClick", (_arg) => {
            downloadCSV(patternInput_2[1], patternInput[1], patternInput_1[1], projectId, filters);
        }]))))))))))))),
        title: "Export as CSV",
    });
}

